import { element } from '../../../core/elements';
import { ValueLabel } from '../../../primitives/label/label';
import Group from '../../../primitives/shape/Group';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export const BarGroupMarkLabels = element(function BarGroupMarkLabels(_ref) {
  let {
    barGroups,
    hide
  } = _ref;
  if (hide) return null;
  return barGroups.map(barGroup => /*#__PURE__*/_jsx(Group, {
    left: barGroup.x0,
    children: barGroup.bars.map(bar => {
      if (!bar.width || !bar.height) return null;
      return /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsx(ValueLabel, {
          x: bar.x + bar.width / 2,
          y: bar.y + bar.height / 2,
          color: bar.color,
          children: bar.yValue.toString()
        }, `bar-stack-label-${barGroup.index}-${bar.index}`)
      });
    })
  }, `bar-group-labels-${barGroup.index}-${barGroup.x0}`));
});